<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
    [spinner]="spinkit.skThreeBounce">
</ng-http-loader>

<!-- Food Menu Dishes Starts -->
<div style="padding-bottom: 4rem;">
    <div class="container-fluid">
        <div class=" d-flex" style="margin-top: 7%;padding-left: 13px; align-items: center;">
            <div class="">
            </div>
            <div
                style="display: flex;flex: 1; justify-content: space-between; align-items: center; padding-right: 10px;">
                <div class="restoName">
                    <img *ngIf="restoLogo" [src]="restoLogo" alt="" alt="logo" style="width: 30px;margin-right: 10px;">
                    {{restoName}}
                </div>
            </div>

            <div class="restoDescription "></div>
        </div>
    </div>


    <div class="dish_list_bottom">
        <div class="container-fluid" style="position: sticky;top: 0;z-index: 11;">
            <div class="searchbg">
                <div class="form-group d-flex">
                    <div class="searchbar mt-3">
                        <i class="fa fa-search"></i><span class="search-next">|</span>
                        <input type="text" class="textvalue ml-2" placeholder="Search for dishes available ..." />
                    </div>
                    <div style="margin-top: 20px;margin-left:15px;cursor: pointer;">
                        <!-- <img src="../../../../assets/img/imagescreenpre.png" alt="" (click)="showPreference()"> -->
                        <img src="../../../../assets/img/imagescreenpre.png" alt="" (click)="showMessage()">
                    </div>
                </div>
            </div>

        </div>



        <div>
            <div id="id_{{item.key}}" *ngFor="let item of newItems">
                <div class="container-fluid">
                    <div class="catNames">
                        <span>{{item.key}}</span>
                    </div>

                </div>
                <div>
                    <div *ngFor="let value of item.value">
                        <div class="container" style="padding-left: 20px !important; ">
                            <div class="d-flex">
                                <div class="subNameCointainer" style="width:75%;margin-top: -15px;">
                                    <div class="mt-4">

                                        <div *ngIf="value.topChoice == 'Yes' && value.canEat != 'No' && value.dpAvailable != 'No'"
                                            class="rankedUp">
                                            <div class="tooltip">
                                                Ranked Up
                                                <img src="../../../../assets/img/ranked-up.svg" alt=""
                                                    style="cursor: pointer;" width="20">
                                                <span class="tooltiptext tooltipRankUp"><span>This dish is ranked up as
                                                        it contains some
                                                        ingredients that you like</span></span>
                                            </div>
                                        </div>
                                        <div class="headers ">
                                            <div>
                                                <span style="cursor: pointer;">{{value.name}}</span>
                                                <div *ngIf="value.canEat == 'No' || value.dpAvailable == 'No';else checkOption"
                                                    style="position: relative; display: inline-block !important;">
                                                    <div class="tooltip">
                                                        <img src="/assets/img/unsuitable-dietary-prefernces.svg" alt=""
                                                            style="cursor: pointer; min-width: 20px; padding-bottom: 5px; margin-left: 4px;"
                                                            width="20">
                                                        <span class="tooltiptext">This dish is not suitable</span>
                                                    </div>
                                                </div>
                                                <ng-template #checkOption>
                                                    <div *ngIf="value.canEat == 'Yes' || value.dpAvailable == 'Yes'"
                                                        style="position: relative; display: inline-block !important;">
                                                        <div class="tooltip">
                                                            <img src="../../../../assets/img/unsuitable-dietary-prefernces-orange.svg"
                                                                alt=""
                                                                style="cursor: pointer; min-width: 20px;padding-bottom: 5px; margin-left: 4px;"
                                                                width="20">
                                                            <span class="tooltiptext">This dish may have option for
                                                                you</span>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="price" *ngIf="value.dish_option.length == 0">
                                        <span>
                                            &#163; {{value.price}}
                                        </span>
                                    </div>
                                    <div class="price" *ngIf="value.dish_option.length > 0">
                                        <div style="width: max-content;">
                                            <div *ngFor="let dishItem of value.dish_option" class="dishOption">
                                                <div>{{dishItem.option_name}}</div>
                                                <div class="dishPrice">:<span>&#163; </span> {{dishItem.option_price}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="textpara" style="cursor: pointer;">
                                        {{value.description}}
                                    </div>

                                    <div class="">
                                        <div *ngIf="value.overallRating == 'NA'" class="Na-star-rating">
                                            <img src="../../../../assets/img/white-star.svg" alt=""><span
                                                class="rating-text-new">0</span>
                                        </div>

                                        <div *ngIf="value.overallRating != 'NA'" class="Na-star-rating">
                                            <img src="../../../../assets/img/start-icon.svg" alt=""><span
                                                class="rating-text-new">{{value.overallRating}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex">
                                        <div>
                                            <button class="add-btnnew" (click)="showMessage()">ADD
                                                <span class="right-bar">&nbsp;</span> <span class="quantity-counter">{{'
                                                    '}}</span>
                                            </button>
                                        </div>

                                        <div *ngIf="value.addOnExists" class="customise-text">Customisable</div>

                                        <button class="info-icon-svg"
                                            (click)="showMessage()"><img
                                                style="min-height: 25px;" src="../../../../assets/img/info.svg"
                                                alt=""></button>
                                    </div>
                                    <div *ngIf="value.addOnExists" class="customise-text">Customisable</div>
                                    <div class="allergens_btn_main_div" (click)="showMessage()"
                                        *ngIf="value.dish_allergens.length > 0">
                                        <span>Allergens</span>
                                        <img src="../../../../assets/img/dropdwon_icon_red.svg" alt="">
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div class="container-fluid" style="border-bottom: 1px solid #ebebeb;">
                            &nbsp;
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="container d-flex justify-content-end">
            <img src="./assets/img/Group 1361.svg" class="menu-img" alt="menu" width="80" (click)="menuClick()">
        </div>
    </div>
</div>


<div class="container-fluid">
    <div class="d-flex justify-content-between">
        <div>
            <ul class="nav nav-pills row">
                <li class="nav-item col-xs-3">
                    <a (click)="showMessage()" routerLinkActive="active" class="nav-link" #rla="routerLinkActive">
                        <!-- <tc-icon [iconClass]="'icofont-restaurant-menu'" [tcFontSize]="24"></tc-icon> -->
                        <img src="./assets/img/menu.svg" alt="">
                        <!-- <img [src]="rla.isActive ? iconmenu : iconAtvmenu" alt="menu" /> -->

                        <span class="nav__text">Menu</span>
                    </a>
                </li>
                <li class="nav-item col-xs-3">
                    <a class="nav-link" (click)="showMessage()">
                        <img src="./assets/img/cart.svg" alt="">
                        <!-- <tc-icon [iconClass]="'icofont-shopping-cart'" [tcFontSize]="25"></tc-icon> -->
                        <span class="nav__text">Cart</span>
                    </a>
                </li>
                <li class="nav-item col-xs-3">
                    <a routerLinkActive="active" class="nav-link" (click)="showMessage()">
                        <img src="./assets/img/order.svg" alt="">
                        <!-- <tc-icon [iconClass]="'icofont-food-basket'" [tcFontSize]="26"></tc-icon> -->
                        <span class="nav__text">Orders</span>
                    </a>
                </li>
                <li class="nav-item col-xs-3 py-1">
                    <a routerLinkActive="active" class="nav-link" (click)="showMessage()">
                        <!-- <tc-icon [iconClass]="'icofont-user-alt-5'" [tcFontSize]="22"></tc-icon> -->
                        <img src="./assets/img/profile.svg" alt="">
                        <span class="nav__text">Profile</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>

</div>